export interface BenchmarkContract {
  conId: number;
  symbol: string;
  label: string;
}

export const BENCHMARK_CONTRACTS: BenchmarkContract[] = [
  { conId: 416904, symbol: "SPX", label: "S&P 500" },
  { conId: 756733, symbol: "SPY", label: "SPY" },
  { conId: 416843, symbol: "NDX", label: "Nasdaq 100" },
  { conId: 320227571, symbol: "QQQ", label: "QQQ" },
  { conId: 9579970, symbol: "IWM", label: "Russell 2000" },
];

export const DEFAULT_BENCHMARK_SYMBOL = "SPX";

export function getBenchmarkBySymbol(symbol: string): BenchmarkContract | undefined {
  return BENCHMARK_CONTRACTS.find((b) => b.symbol === symbol);
}

/**
 * Benchmarks offered on the Discover product-detail "Net & Benchmark" chart
 * view: S&P 500, Nasdaq 100, Russell 2000 only (no SPY / QQQ ETFs). Order is
 * the overlay order; SPX is selected by default.
 */
export const DETAIL_BENCHMARK_SYMBOLS = ["SPX", "NDX", "IWM"] as const;

export const DETAIL_BENCHMARKS: BenchmarkContract[] = DETAIL_BENCHMARK_SYMBOLS.map(
  (symbol) => BENCHMARK_CONTRACTS.find((b) => b.symbol === symbol)!
);
